import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Zap, Crown } from "lucide-react";

const LABELS = { reply: "réponses", analyze: "analyses", content: "scripts", situation: "analyses" };

export default function RemainingCounter({ kind = "reply", trigger }) {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/usage/today");
      setInfo(data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load, trigger]);

  if (!info) return null;
  if (info.unlimited) {
    return (
      <div data-testid="usage-unlimited" className="inline-flex items-center gap-2 text-xs text-gold border border-gold/30 rounded-full px-3 py-1.5">
        <Zap size={13} /> IA illimitée
      </div>
    );
  }
  const u = info.usage?.[kind];
  if (!u) return null;
  const low = u.remaining <= 1;

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }}
        data-testid="usage-counter"
        className={`flex flex-wrap items-center gap-3 rounded-xl px-4 py-2.5 text-sm border ${
          low ? "border-gold/40 bg-gradient-to-r from-[#BF953F]/15 to-transparent" : "border-white/10 bg-white/[0.03]"}`}>
        <span className={low ? "text-white" : "text-white/60"}>
          Il vous reste <span className="text-gold font-medium">{u.remaining}</span> {LABELS[kind]} aujourd'hui.
        </span>
        {!user?.is_premium && (low || u.remaining === 0) && (
          <Link to="/premium" data-testid="usage-upgrade"
            className="inline-flex items-center gap-1.5 gold-gradient text-black rounded-full px-3 py-1 text-xs font-medium">
            <Crown size={13} /> Passer à Premium
          </Link>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
